import clsx from 'clsx';

const HeadingField = ( { field } ) => {

    const { title, cssclass, title_type = 'h3' } = field;

    const HeadingTag = title_type;

    return (
        <div
            className={ clsx(
                'thwcfd-heading-field',
                cssclass?.split( ',' ).map( ( c ) => c.trim() )
            ) }
        >
            <HeadingTag className="thwcfd-heading-text">
                { title || '' }
            </HeadingTag>
        </div>
    );
};

export default HeadingField;

